import { useEffect, useMemo, useRef, useState } from 'react';

export const useGenericCarousel = ({ wrapperRef, spaceBetween }) => {
  const trackRef = useRef(null);
  const progress = useRef(0);
  //----DRAG----
  const [start, setStart] = useState(0);
  const [change, setChange] = useState(0);
  const [canDoCarousel, setCanDoCarousel] = useState(false);

  const handleNext = () => {
    if (progress.current >= trackRef.current.offsetWidth) {
      progress.current = 0;
      trackRef.current.style.left = `-${progress.current}px`;
    } else if (
      trackRef.current.offsetWidth -
        wrapperRef.current.offsetWidth +
        spaceBetween <
      progress.current
    ) {
      progress.current = trackRef.current.offsetWidth;
      trackRef.current.style.left = `-${trackRef.current.offsetWidth -
        wrapperRef.current.offsetWidth}px`;
    } else if (
      progress.current +
        trackRef.current.firstChild.offsetWidth +
        spaceBetween >
      trackRef.current.offsetWidth - wrapperRef.current.offsetWidth
    ) {
      progress.current = trackRef.current.offsetWidth;
      trackRef.current.style.left = `-${trackRef.current.offsetWidth -
        wrapperRef.current.offsetWidth}px`;
    } else {
      progress.current +=
        trackRef.current.firstChild.offsetWidth + spaceBetween;
      trackRef.current.style.left = `-${progress.current}px`;
    }
  };

  const handlePrev = () => {
    if (progress.current === 0) return;

    if (progress.current === trackRef.current.offsetWidth) {
      progress.current =
        trackRef.current.offsetWidth -
        wrapperRef.current.offsetWidth -
        trackRef.current.firstChild.offsetWidth;
      trackRef.current.style.left = `-${progress.current}px`;
    } else if (
      progress.current >=
      trackRef.current.firstChild.offsetWidth + spaceBetween
    ) {
      progress.current -=
        trackRef.current.firstChild.offsetWidth + spaceBetween;
      trackRef.current.style.left = `-${progress.current}px`;
    } else if (progress.current <= trackRef.current.firstChild.offsetWidth) {
      progress.current = 0;
      trackRef.current.style.left = `-${progress.current}px`;
    }
  };

  //----DRAG DEL CARRUSEL----
  const handleDragStart = e => {
    setStart(e.clientX);
  };

  const handleDragOver = e => {
    e.preventDefault();
    let touch = e.clientX;
    setChange(start - touch);
  };

  const handleDragEnd = () => {
    if (
      change > 0 &&
      progress.current <
        trackRef.current.offsetWidth -
          trackRef.current.parentElement.offsetWidth
    ) {
      handleNext();
    } else if (progress.current > 0) {
      handlePrev();
    }
  };

  const calculateWidthPoster = () => {
    try {
      const poster = trackRef?.current?.childNodes?.[0];
      if (poster) {
        const posterStyles = window?.getComputedStyle(poster);
        const widthString = posterStyles?.getPropertyValue('width');
        const marginrightString = posterStyles?.getPropertyValue(
          'margin-right',
        );

        const width = widthString?.replace('px', '');
        const marginright = marginrightString?.replace('px', '');

        const widthNum = Number(width);
        const marginrightNum = Number(marginright);

        const totalWidthPoster = widthNum + marginrightNum;
        return totalWidthPoster;
      }
      return 0;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  const widthContentsCarouselDreams = () => {
    try {
      const carousel = trackRef?.current?.parentNode;
      if (carousel) {
        const carrouselDreamsStyles = window?.getComputedStyle(carousel);
        const widthCarouselDreamsString = carrouselDreamsStyles?.getPropertyValue(
          'width',
        );
        const widthCarouselDreams = widthCarouselDreamsString.replace('px', '');
        const widthCarouselDreamsNum = Number(widthCarouselDreams);
        return widthCarouselDreamsNum;
      }
      return 0;
    } catch (error) {
      console.error(error);
      return 0;
    }
  };

  useEffect(
    () => {
      if (!wrapperRef.current) return setCanDoCarousel(false);
      if (
        trackRef.current &&
        trackRef.current.offsetWidth > wrapperRef.current?.offsetWidth
      ) {
        return setCanDoCarousel(true);
      }
      return setCanDoCarousel(false);
    },
    [trackRef.current, wrapperRef.current],
  );

  return {
    handleNext,
    handlePrev,
    trackRef,
    handleDragEnd,
    handleDragOver,
    handleDragStart,
    canDoCarousel,
  };
};
